import Vue from 'vue';
import VueRouter from 'vue-router';
// import authentication from './authentication'
import login from './login';
import lottery from './lottery';
import technician from './technician';
import channel from './channel';
import service from './service';
import center from './center';
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes:[
        ...login,...lottery,...technician,...channel,...service,...center
    ]
});

export default router;
